import React from 'react';
import { styles } from './FooterNavigation.css';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import { Link } from '../../PlatformFunctionality';
import { NavColumn } from '../types';
import { useTrackingContext } from '../../Tracking';

export type FooterNavigationProps = {
  navOptions: Array<NavColumn>;
};

export const FooterNavigation = ({ navOptions: navOptions }: FooterNavigationProps) => {
  const { tracker } = useTrackingContext();

  const handleFooterLinkClick = ({ category, label }: { category: string; label: string }) => {
    tracker.group = category?.trim();
    tracker.trackClick({ label: label?.trim() });
  };

  return navOptions.length ? (
    <div className={styles.navigationContainer}>
      {navOptions.map(category => {
        return (
          <div className={styles.navigationColumn} key={category.label}>
            <h6 className={styles.columnHeading}>
              <DomFont>{category.label}</DomFont>
            </h6>
            <ul className={styles.menu} aria-labelledby={category.label}>
              {category.options.map(link => {
                return (
                  <li key={link.url} className={styles.navItem}>
                    <Link
                      href={link.url}
                      onClick={() => handleFooterLinkClick({ category: category.label, label: link.label })}
                    >
                      {link.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
    </div>
  ) : null;
};
